import { DateTime } from 'luxon';
import { CustomSlot } from '../../../../components/sheet/slots';
import { BlockSummarySlot } from '../types';

export const MONTH_DAY_COUNT = 31;

/** Diameter (in CSS px) shared by the Catapult/Match Stats dot and the cross-block indicator so both stay visually identical. */
export const SOURCE_DOT_DIAMETER_PX = 8;

export function getSlotsForMonth(
  x: number,
  y: number,
  month: number,
  year: number,
  onRenderDay: (x: number, y: number, day: number) => BlockSummarySlot,
  useDisabledSlot = false,
) {
  const slots: BlockSummarySlot[] = [];
  const daysInMonth = DateTime.fromObject({ month, year }).daysInMonth;

  // For each day in the month, add a slot for each day
  for (let i = 0; i < MONTH_DAY_COUNT; i++) {
    // if the month has the day, add the day slot
    if (daysInMonth && i < daysInMonth) {
      slots.push(onRenderDay(x++, y, i + 1));
    } else {
      slots.push(EmptySlot(x++, y, undefined, useDisabledSlot));
    }
  }
  return slots;
}

export const DisabledSlot = (x: number, y: number): BlockSummarySlot => {
  return EmptySlot(x, y, 'bg-gray-100', true);
};

export const EmptySlot = (
  x: number,
  y: number,
  style?: string,
  disabled?: boolean,
): BlockSummarySlot => {
  return new CustomSlot({ x, y }, 1, 1, disabled ?? false, () => <></>, {
    className: style,
    disableContextMenu: true,
  });
};
